import { render, staticRenderFns } from "./Aliado_info_secundaria.vue?vue&type=template&id=a00d0102&"
import script from "./Aliado_info_secundaria.vue?vue&type=script&lang=js&"
export * from "./Aliado_info_secundaria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports